'use client'
import { EPageName } from "@/util/enum"
import SingleSwiper from "@/components/ui/swiper/SingleSwiper"
import LaserHairPackageCard from "./LaserHairPackageCard"
import StaticPackageCard from "./StaticPackageCard"
import { useIsMobile } from "@/components/ui/hooks/useIsMobile"

interface LaserHairSwiperItem {
    slug: string,
    data_image: string,
    alt_name: string,
    heading_text: string,
    description_text: string,
    badges?: string[],
    badgesHeading?: string,
}

interface LaserHairSwiperProps {
    crouselData: LaserHairSwiperItem[],
    isStaticCard?: boolean,
}

const LaserHairSwiperIndex = ({ crouselData, isStaticCard = false }: LaserHairSwiperProps) => {

    const isMobile = useIsMobile();

    return (
        <div className="w-full mt-2.5">
            <SingleSwiper
                pageName={EPageName?.LASERHAIRPACKAGE}
                showPagination={isMobile}
                crouselData={crouselData}
                renderItem={(item) => (
                    (isStaticCard)
                        ?
                        <StaticPackageCard heading_text={item?.heading_text} description_text={item?.description_text} slug={item?.slug} badges={item?.badges} badgesHeading={item?.badgesHeading ?? ""} />
                        :
                        <LaserHairPackageCard data_image={item?.data_image} alt_name={item?.alt_name} heading_text={item?.heading_text} description_text={item?.description_text} slug={item?.slug} />
                )} />
        </div>
    )
}

export default LaserHairSwiperIndex